/*
 * Kalmix custom code
 * File: assets/kmx-home-signal.js
 * Version: 1008.1
 * History:
 * - 1008.1 Fix state named SINGLE (status line and landing label), consistent with
 *   03 / 06 and SCOPE.
 * - 1005.6 Hover: the satellite's own label switches to the highlighted style
 *   (ID · EL) with a selection ring and brighter line; one extra line below,
 *   left-aligned with the label: constellation · orbit · AZ. Knowledge-dot
 *   tips stay on two lines and are placed fully inside the frame (right side,
 *   else left side, else shifted inward).
 * - 1005.5 Hover no longer opens a card: one extra canvas line appears under the
 *   satellite (constellation · PRN · orbit · EL). Status line drops the mask
 *   (SATS IN VIEW · USED · AUTONOMOUS (SPP)). Mobile is simplified: icons and
 *   uniform thin lines only — no labels, tiers, broadcast dashes, pulses,
 *   mask fan or hover.
 * - 1005.4 Highlighted lines slightly dimmer (.42). Only satellites fully on screen
 *   (label inside the frame, clear of the clock) can be among the top three.
 *   Hover card per satellite: constellation, PRN, orbit, elevation / azimuth,
 *   used or below the 15° mask. Knowledge-dot tips flip to the side with room.
 *   SATS IN VIEW / USED now model a realistic multi-GNSS sky over Four Corners
 *   (GPS, GLONASS, Galileo, BeiDou; ~34–40 in view, ~26–31 above the mask),
 *   drifting slowly with time and identical for every visitor; the drawn
 *   satellites are a subset. QZSS removed (not visible from Four Corners).
 * - 1005.3 Satellites are drawn by elevation as seen from Four Corners:
 *   above 35° a clear line, 15–35° a fainter line, below the 15° mask no line,
 *   only short broadcast dashes (tracked, not used). The three highest
 *   satellites are highlighted with brighter icons, IDs and "EL xx°".
 *   Pulses are thinner and rarer. A faint 15° elevation-mask fan at the
 *   landing point (desktop). Frequency bands removed from labels.
 *   Clock shows raw GPS time (WN · TOW) and UTC with the 18 s leap offset.
 *   Live status line: sats in view · used · AUTONOMOUS (SPP); the landing
 *   label uses the same live count. Knowledge dot Q is placed beside the clock.
 *   Displayed elevation is compressed (raw × 0.85 − 8°) so about a fifth of the
 *   satellites sit below the mask; satellites fade out around the clock block.
 *   Mobile: orbit rings are stretched (×1.25 / ×1.85) so satellites pass the top
 *   sky band; lines are fainter there because they cross the text column.
 * - 1005.2 Moving constellation of 20 satellites on seven orbit rings; each
 *   travels its ring's visible sky arc and re-enters; lines to Four Corners;
 *   UTC with two decimals at ~30 Hz.
 * - 1005.1 Initial delivery of the 01 SIGNAL (Hero) data layer. Aligns the Blender
 *   earth render via hero-earth.json (object-fit cover, right bottom), draws a
 *   procedural placeholder earth when no render is set, main beam to Four Corners
 *   (36.998977 N, 109.045172 W), runs only while visible, static under reduced motion.
 */
(function () {
  function rng(seed) { return function () { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
  var GPS_EPOCH = Date.UTC(1980, 0, 6);
  var LEAP = 18;                       // GPS − UTC（闰秒），自 2017 年起为 18 s
  var MASK = 15, HIGH = 35;            // 截止仰角 / 高仰角（度）

  function pad(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }
  function groupTow(v) { var s = v.toFixed(2), i = s.indexOf('.'), a = s.slice(0, i); a = a.length > 3 ? a.slice(0, a.length - 3) + ' ' + a.slice(-3) : a; return a + s.slice(i); }

  function initSignal(sec) {
    if (sec.__kmxInit) return; sec.__kmxInit = true;
    var KMX = window.KMX || { reduce: false, onVisible: function () {}, onEnter: function () {} };
    var reduce = KMX.reduce;
    var MONO = KMX.mono || 'ui-monospace, monospace';
    var c = sec.querySelector('.kmx-signal__sky');
    var img = sec.querySelector('.kmx-signal__earth img');
    var clockBox = sec.querySelector('.kmx-signal__clock');
    var gpsEl = sec.querySelector('.kmx-signal__gps');
    var utcEl = sec.querySelector('.kmx-signal__utc');
    var statusEl = sec.querySelector('.kmx-signal__status');
    var meta = {};
    try { meta = JSON.parse(sec.getAttribute('data-earth') || '{}'); } catch (e) { meta = {}; }
    var LABEL_COORD = sec.getAttribute('data-coord') || '';
    var LABEL_ALT = sec.getAttribute('data-fix') || '';
    var mqMobile = window.matchMedia('(max-width: 860px)');

    var S, geo, earthTex = null, running = false;

    function fit() {
      var r = c.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
      c.width = Math.max(1, Math.round(r.width * d)); c.height = Math.max(1, Math.round(r.height * d));
      var x = c.getContext('2d'); x.setTransform(d, 0, 0, d, 0, 0);
      return { x: x, w: r.width, h: r.height };
    }
    function imageReady() { return img && img.complete && img.naturalWidth > 0; }

    function build() {
      S = fit();
      var w = S.w, h = S.h, mob = mqMobile.matches;
      // 手机端没有单独上传手机版渲染时，<picture> 回落到桌面图，参数也用桌面
      var m = (mob && sec.getAttribute('data-has-mobile') === '1') ? meta.mobile : meta.desktop;
      var g = null;
      if (imageReady() && m && m.radius > 0 && m.size) {
        // 与 CSS 一致：object-fit: cover; object-position: right bottom
        var s = Math.max(w / m.size[0], h / m.size[1]);
        var ox = w - m.size[0] * s, oy = h - m.size[1] * s;
        g = { cx: ox + m.center[0] * s, cy: oy + m.center[1] * s, R: m.radius * s,
              L: { x: ox + m.fourCorners[0] * s, y: oy + m.fourCorners[1] * s }, image: true };
      } else {
        var R = Math.max(w, h) * (mob ? .62 : .56);
        var cx = w * (mob ? .88 : .93), cy = h + R * (mob ? .9 : .6);
        var a = mob ? -1.62 : -1.98;
        g = { cx: cx, cy: cy, R: R, L: { x: cx + R * Math.cos(a), y: cy + R * Math.sin(a) }, image: false };
        earthTex = makeEarth(R);
      }
      // 落点的"天顶"方向：从地心指向落点
      var ux = g.L.x - g.cx, uy = g.L.y - g.cy, ul = Math.sqrt(ux * ux + uy * uy) || 1;
      g.up = { x: ux / ul, y: uy / ul };
      g.mob = mob;
      geo = g;
      arcs = null;
      setDot('P', w * (mob ? .58 : .62), h * (mob ? .2 : .2));
      setDot('L', g.L.x - 24, g.L.y + 30);
      placeClockDot();
      if (reduce) draw(0, 0);
    }
    function setDot(k, x, y) {
      var el = sec.querySelector('.kmx-kdot[data-anchor="' + k + '"]');
      if (!el) return;
      el.style.left = x + 'px'; el.style.top = y + 'px';
      placeTip(el, x);
    }
    // 提示框（两行、不换行）完整放在画面内：优先右侧，放不下换左侧，仍放不下则向内平移
    function placeTip(el, x) {
      var tip = el.querySelector('.kmx-kdot__tip'); if (!tip || !S) return;
      var tw = tip.offsetWidth, gap = 22, m = 12, left;
      var right = x + gap + tw <= S.w - m, leftOk = x - gap - tw >= m;
      if (right) left = x + gap; else if (leftOk) left = x - gap - tw; else left = Math.max(m, Math.min(S.w - m - tw, x - tw / 2));
      el.classList.toggle('kmx-kdot--left', !right);
      tip.style.left = (left - x + 13) + 'px'; tip.style.right = 'auto';
    }
    function placeAllTips() { sec.querySelectorAll('.kmx-kdot').forEach(function (el) { placeTip(el, parseFloat(el.style.left) || 0); }); }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeAllTips);

    // 时间知识点：放在右上角时间块的左侧
    // 同时记录时间块区域（相对 section），卫星在这里淡出
    function placeClockDot() {
      if (!clockBox || !geo) return;
      var sr = sec.getBoundingClientRect(), cr = clockBox.getBoundingClientRect();
      if (!cr.width) { geo.clock = null; return; }
      setDot('Q', cr.left - sr.left - 18, cr.top - sr.top + cr.height / 2);
      geo.clock = geo.mob ? null : { l: cr.left - sr.left - 40, b: cr.bottom - sr.top + 24 };
    }

    function makeEarth(R) {
      var size = Math.ceil(R * 2), o = document.createElement('canvas'); o.width = size; o.height = size;
      var g = o.getContext('2d'); g.save(); g.beginPath(); g.arc(R, R, R, 0, 7); g.clip();
      var lg = g.createRadialGradient(R * .55, R * .25, R * .05, R * .9, R * .9, R * 1.15);
      lg.addColorStop(0, '#173647'); lg.addColorStop(.45, '#0c1f2b'); lg.addColorStop(1, '#03080c');
      g.fillStyle = lg; g.fillRect(0, 0, size, size);
      var r = rng(7);
      for (var i = 0; i < 140; i++) {
        var px = r() * size, py = r() * size * .7, rad = R * (.03 + r() * .12);
        var gg = g.createRadialGradient(px, py, 0, px, py, rad);
        gg.addColorStop(0, 'rgba(88,140,150,.07)'); gg.addColorStop(1, 'rgba(88,140,150,0)');
        g.fillStyle = gg; g.beginPath(); g.arc(px, py, rad, 0, 7); g.fill();
      }
      var sh = g.createLinearGradient(0, 0, size, size); sh.addColorStop(.35, 'rgba(0,0,0,0)'); sh.addColorStop(1, 'rgba(0,0,0,.65)');
      g.fillStyle = sh; g.fillRect(0, 0, size, size); g.restore();
      return o;
    }

    var rr = rng(3);
    var stars = []; for (var i = 0; i < 110; i++) stars.push([rr(), rr() * .8, rr() * 1.1 + .2]);

    /* ---- 星座：多条轨道环绕地球；每颗卫星沿所在轨道的可见天空弧段运动，出画后从另一端重新进入 ---- */
    var RINGS = [
      { kx: 1.10, ky: 1.20, tilt: 0 }, { kx: 1.25, ky: 1.32, tilt: -.25 }, { kx: 1.15, ky: 1.45, tilt: .30 },
      { kx: 1.30, ky: 1.25, tilt: -.40 }, { kx: 1.60, ky: 1.45, tilt: .12 }, { kx: 1.35, ky: 1.62, tilt: -.05 },
      { kx: 2.20, ky: 1.50, tilt: .20 }
    ];
    // 画面上画 20 颗：GPS 7 · Galileo 5 · BeiDou 6 · GLONASS 2（单色，只靠编号区分）。
    // QZSS 覆盖亚太，在 Four Corners 看不到，不放。
    var PRN = ['G07', 'G13', 'G28', 'G19', 'G30', 'G05', 'G21', 'E11', 'E24', 'E05', 'E19', 'E31',
      'C23', 'C37', 'C12', 'C25', 'C34', 'C19', 'R05', 'R18'];
    var CONST = { G: 'GPS', E: 'Galileo', C: 'BeiDou', R: 'GLONASS', J: 'QZSS' };
    function orbitOf(n) { return n[0] === 'J' ? 'IGSO' : 'MEO'; }
    var sats = PRN.map(function (n, i) {
      var ring = i % RINGS.length, slot = Math.floor(i / RINGS.length), per = Math.ceil(PRN.length / RINGS.length);
      return { n: n, ring: ring, u: (slot + .2 + rr() * .6) / per, dir: (ring % 2 ? 1 : -1),
        dur: 42000 + rr() * 30000, next: 1200 + rr() * 4000 };
    });
    var arcs = null, pulses = [], lt = 0, mx = 0, my = 0, lastClock = 0, lastStatus = 0;
    window.addEventListener('mousemove', function (e) { mx = e.clientX / window.innerWidth - .5; my = e.clientY / window.innerHeight - .5; }, { passive: true });

    function ringPos(ri, a, par) {
      // 手机竖屏：地球压在底部，轨道需拉高才能经过上方天空
      var r = RINGS[ri], sx = geo.mob ? 1.25 : 1, sy = geo.mob ? 1.85 : 1;
      var x0 = Math.cos(a) * geo.R * r.kx * sx, y0 = Math.sin(a) * geo.R * r.ky * sy;
      var cs = Math.cos(r.tilt), sn = Math.sin(r.tilt);
      return { x: geo.cx + x0 * cs - y0 * sn - (par ? mx * 10 : 0), y: geo.cy + x0 * sn + y0 * cs - (par ? my * 6 : 0) };
    }
    function smooth(e0, e1, v) { var t = Math.min(1, Math.max(0, (v - e0) / (e1 - e0))); return t * t * (3 - 2 * t); }
    // 可见度：地球外、屏幕内；桌面避开左侧文字区，手机只在上方
    function fade(p) {
      var w = S.w, h = S.h, dx = p.x - geo.cx, dy = p.y - geo.cy;
      if (dx * dx + dy * dy < geo.R * geo.R * 1.08) return 0;
      var f = smooth(-10, 30, p.y) * smooth(-10, 30, w - p.x) * smooth(-10, 30, p.x);
      f *= geo.mob ? (1 - smooth(h * .13, h * .2, p.y)) : smooth(w * .34, w * .46, p.x) * (1 - smooth(h * .62, h * .72, p.y));
      // 避开右上角的时间块
      var k = geo.clock;
      if (k) f *= 1 - smooth(k.l - 40, k.l, p.x) * (1 - smooth(k.b, k.b + 40, p.y));
      return f;
    }
    function computeArcs() {
      arcs = RINGS.map(function (r, ri) {
        var N = 720, vis = [], k, best = [0, 0], cur = -1;
        for (k = 0; k < N; k++) vis.push(fade(ringPos(ri, k / N * Math.PI * 2, false)) > .02);
        for (k = 0; k < N * 2; k++) {
          if (vis[k % N]) { if (cur < 0) cur = k; if (k - cur > best[1] - best[0]) best = [cur, k]; }
          else cur = -1;
        }
        var a0 = best[0] / N * Math.PI * 2, a1 = best[1] / N * Math.PI * 2;
        if (a1 - a0 < .05) { a0 = 3.6; a1 = 5.6; }
        return [a0 - .03, a1 + .03];
      });
    }
    function satPos(s) { var A = arcs[s.ring], u = s.dir > 0 ? s.u : 1 - s.u; return ringPos(s.ring, A[0] + (A[1] - A[0]) * u, true); }
    // 仰角：卫星方向与落点天顶方向的夹角（90° = 正上方）。
    // 画面里低仰角区域大多被地球挡住，因此按 0.85 压缩并下移 8°，让约两成卫星落在截止仰角以下（示意值）
    function elevation(p) {
      var vx = p.x - geo.L.x, vy = p.y - geo.L.y, vl = Math.sqrt(vx * vx + vy * vy) || 1;
      var d = (vx * geo.up.x + vy * geo.up.y) / vl;
      var raw = Math.asin(Math.max(-1, Math.min(1, d))) * 180 / Math.PI;
      return Math.max(0, raw * .85 - 8);
    }

    function line(x, a, b, style, width, dash) {
      x.strokeStyle = style; x.lineWidth = width; x.setLineDash(dash || []);
      x.beginPath(); x.moveTo(a.x, a.y); x.lineTo(b.x, b.y); x.stroke(); x.setLineDash([]);
    }

    function draw(t, dt) {
      var x = S.x, w = S.w, h = S.h, R = geo.R, cx = geo.cx, cy = geo.cy, L = geo.L;
      if (!arcs) computeArcs();
      x.clearRect(0, 0, w, h);
      // 星点：避开地球
      for (var i = 0; i < stars.length; i++) {
        var sx = stars[i][0] * w - mx * 4, sy = stars[i][1] * h - my * 3;
        if ((sx - cx) * (sx - cx) + (sy - cy) * (sy - cy) < R * R * 1.01) continue;
        x.fillStyle = 'rgba(200,225,240,' + (.08 + .16 * Math.pow(Math.sin(t * .0006 + stars[i][0] * 40), 2)) + ')';
        x.fillRect(sx, sy, stars[i][2], stars[i][2]);
      }
      // 轨道环（极淡）
      x.lineWidth = 1; x.strokeStyle = 'rgba(124,200,255,.04)';
      var esx = geo.mob ? 1.25 : 1, esy = geo.mob ? 1.85 : 1;
      RINGS.forEach(function (r) { x.beginPath(); x.ellipse(cx - mx * 10, cy - my * 6, R * r.kx * esx, R * r.ky * esy, r.tilt, 0, Math.PI * 2); x.stroke(); });
      // 占位地球（有渲染图时由 <img> 显示）
      if (!geo.image && earthTex) {
        var atm = x.createRadialGradient(cx, cy, R * .985, cx, cy, R * 1.06);
        atm.addColorStop(0, 'rgba(124,200,255,.22)'); atm.addColorStop(.35, 'rgba(124,200,255,.06)'); atm.addColorStop(1, 'rgba(124,200,255,0)');
        x.fillStyle = atm; x.beginPath(); x.arc(cx, cy, R * 1.06, 0, 7); x.fill();
        x.drawImage(earthTex, cx - R, cy - R, R * 2, R * 2);
      }
      // 截止仰角扇面（桌面）：落点两侧各一条 15° 线，极淡
      if (!geo.mob) {
        var hx = -geo.up.y, hy = geo.up.x, rad = MASK * Math.PI / 180, len = Math.min(170, w * .12);
        [1, -1].forEach(function (sg) {
          var dx = (hx * sg) * Math.cos(rad) + geo.up.x * Math.sin(rad), dy = (hy * sg) * Math.cos(rad) + geo.up.y * Math.sin(rad);
          line(x, L, { x: L.x + dx * len, y: L.y + dy * len }, 'rgba(191,230,255,.16)', 1, [2, 4]);
        });
        x.font = '9px ' + MONO; x.fillStyle = 'rgba(170,205,225,.32)';
        var ex = L.x + (-hx * Math.cos(rad) + geo.up.x * Math.sin(rad)) * len, ey = L.y + (-hy * Math.cos(rad) + geo.up.y * Math.sin(rad)) * len;
        x.fillText('MASK ' + MASK + '°', ex - 52, ey - 6);
      }

      // 位置、可见度、仰角；仰角最高的三颗高亮
      var list = [];
      sats.forEach(function (s) {
        if (!reduce) { s.u += dt / s.dur; if (s.u >= 1) s.u -= 1; }
        var p = satPos(s), f = fade(p);
        s.p = p; s.f = f; s.el = elevation(p); s.hi = false;
        if (f > .01) list.push(s);
      });
      var used = list.filter(function (s) { return s.el >= MASK; });
      // 前三颗只从"完整在画面里"的卫星中选：标注整段在画面内、不压时间块
      x.font = '10.5px ' + MONO;
      used.filter(function (s) {
        if (geo.mob || s.f < .92) return false;
        var lw = x.measureText(s.n + ' · EL 00°').width, k = geo.clock;
        if (s.p.x - 14 < 0 || s.p.x + 16 + lw > w - 8 || s.p.y - 18 < 0) return false;
        if (k && s.p.x + 16 + lw > k.l && s.p.y - 18 < k.b) return false;
        return true;
      }).sort(function (a, b) { return b.el - a.el; }).slice(0, 3).forEach(function (s) { s.hi = true; });

      list.forEach(function (s) {
        var p = s.p, f = s.f;
        // 手机：只画图标和统一的细线
        if (geo.mob) {
          line(x, p, L, 'rgba(124,200,255,' + (.12 * f) + ')', .7);
          x.fillStyle = 'rgba(207,233,255,' + (.6 * f) + ')';
          x.fillRect(p.x - 2, p.y - 1, 4, 2); x.fillRect(p.x - 6, p.y - .4, 3, .8); x.fillRect(p.x + 3, p.y - .4, 3, .8);
          return;
        }
        if (s.el >= MASK) {
          // 参与定位：实线；高仰角更清楚，前三颗最亮
          var a = (s.hi ? .42 : (s.el >= HIGH ? .28 : .16)) * (geo.mob ? .55 : 1) * (s === hover ? 1.6 : 1);
          var lg = x.createLinearGradient(p.x, p.y, L.x, L.y);
          lg.addColorStop(0, 'rgba(124,200,255,' + (a * .45 * f) + ')'); lg.addColorStop(1, 'rgba(150,212,255,' + (a * f) + ')');
          line(x, p, L, lg, s.hi ? 1.2 : (s.el >= HIGH ? 1 : .8));
        } else {
          // 低于截止仰角：只跟踪不参与，画几段向落点方向"广播"的短虚线
          var vx = L.x - p.x, vy = L.y - p.y, vl = Math.sqrt(vx * vx + vy * vy) || 1; vx /= vl; vy /= vl;
          var reach = Math.min(220, vl * .4), ph = reduce ? 0 : (t / 900 + s.u * 10) % 1;
          for (var k = 0; k < 3; k++) {
            var d0 = ((ph + k / 3) % 1) * reach, d1 = d0 + 14;
            var aa = .22 * f * (1 - d0 / reach);
            line(x, { x: p.x + vx * d0, y: p.y + vy * d0 }, { x: p.x + vx * d1, y: p.y + vy * d1 }, 'rgba(124,200,255,' + aa + ')', 1);
          }
        }
        // 卫星图标与编号（参与定位的显示仰角）
        if (s.hi || s === hover) {
          x.fillStyle = 'rgba(236,247,255,' + f + ')';
          x.fillRect(p.x - 4, p.y - 2, 8, 4); x.fillRect(p.x - 12, p.y - .7, 6, 1.4); x.fillRect(p.x + 6, p.y - .7, 6, 1.4);
          x.font = '10.5px ' + MONO; x.fillStyle = 'rgba(214,236,250,' + (.9 * f) + ')';
          x.fillText(s.n + ' · EL ' + Math.round(s.el) + '°', p.x + 16, p.y - 6);
        } else {
          var dim = s.el >= MASK ? 1 : .55;
          x.fillStyle = 'rgba(207,233,255,' + (.6 * f * dim) + ')';
          x.fillRect(p.x - 2, p.y - 1, 4, 2); x.fillRect(p.x - 6, p.y - .4, 3, .8); x.fillRect(p.x + 3, p.y - .4, 3, .8);
          x.font = '9.5px ' + MONO; x.fillStyle = 'rgba(170,205,225,' + (.36 * f * dim) + ')';
          x.fillText(s.n + (s.el >= MASK ? '  ' + Math.round(s.el) + '°' : ''), p.x + 9, p.y + 3);
        }
        if (s === hover) {
          // 选中：选中环 + 标注下方一行（星座 · 轨道 · 方位角），与上一行左对齐
          x.strokeStyle = 'rgba(124,200,255,.7)'; x.lineWidth = 1; x.beginPath(); x.arc(p.x, p.y, 10, 0, 7); x.stroke();
          x.font = '9.5px ' + MONO; x.fillStyle = 'rgba(170,205,225,' + (.78 * f) + ')';
          x.fillText(CONST[s.n[0]] + ' · ' + orbitOf(s.n) + ' · AZ ' + azimuth(p) + '°', p.x + 16, p.y + 9);
        }
        // 信号脉冲：只在参与定位的线上，偶尔、细、短
        if (!reduce && !geo.mob && s.el >= MASK && t > s.next && f > .5) { pulses.push({ s: s, k: 0 }); s.next = t + (s.hi ? 2600 : 4200 + Math.random() * 5200); }
      });
      for (var j = pulses.length - 1; j >= 0; j--) {
        var q = pulses[j], o = q.s.p; q.k += dt / 2200;
        if (q.k > 1 || q.s.f <= .01 || q.s.el < MASK) { pulses.splice(j, 1); continue; }
        var k0 = Math.max(0, q.k - .06);
        var pa = { x: o.x + (L.x - o.x) * k0, y: o.y + (L.y - o.y) * k0 }, pb = { x: o.x + (L.x - o.x) * q.k, y: o.y + (L.y - o.y) * q.k };
        var pg = x.createLinearGradient(pa.x, pa.y, pb.x, pb.y); pg.addColorStop(0, 'rgba(160,215,255,0)'); pg.addColorStop(1, 'rgba(190,228,255,' + ((q.s.hi ? .55 : .3) * q.s.f) + ')');
        line(x, pa, pb, pg, 1.2);
      }

      // 落点：Four Corners
      var pr = 6 + 2.5 * Math.sin(t * .003);
      x.strokeStyle = 'rgba(124,200,255,.35)'; x.lineWidth = 1; x.beginPath(); x.arc(L.x, L.y, pr + 8, 0, 7); x.stroke();
      x.fillStyle = '#bfe6ff'; x.beginPath(); x.arc(L.x, L.y, 3.2, 0, 7); x.fill();
      var sky = skyStats(Date.now());
      var fixTxt = (LABEL_ALT ? LABEL_ALT + ' · ' : '') + 'SINGLE · ' + sky.used + ' SATS';
      if (!geo.mob) {
        line(x, { x: L.x + 10, y: L.y - 10 }, { x: L.x + 34, y: L.y - 34 }, 'rgba(191,230,255,.4)', 1);
        line(x, { x: L.x + 34, y: L.y - 34 }, { x: L.x + 44, y: L.y - 34 }, 'rgba(191,230,255,.4)', 1);
        x.font = '10px ' + MONO; x.fillStyle = 'rgba(220,236,245,.82)'; x.fillText(LABEL_COORD, L.x + 48, L.y - 31);
        x.fillStyle = 'rgba(143,163,171,.8)'; x.fillText(fixTxt, L.x + 48, L.y - 17);
      }

      // 时间：约 30 Hz；状态行：约 4 Hz
      if (t - lastClock > 33 || reduce) { lastClock = t; tick(!reduce); }
      if (statusEl && (t - lastStatus > 250 || reduce)) {
        lastStatus = t;
        statusEl.textContent = 'SATS IN VIEW ' + pad(sky.view, 2) + ' · USED ' + pad(sky.used, 2) + ' · SINGLE (SPP)';
      }
    }

    // GPS 时间（周数 + 周内秒）与 UTC；GPS = UTC + 18 s
    var clockPlaced = false;
    function tick(fine) {
      if (!gpsEl || !utcEl) return;
      var now = Date.now(), gps = (now - GPS_EPOCH) / 1000 + LEAP;
      var wn = Math.floor(gps / 604800), tow = gps - wn * 604800;
      var iso = new Date(now).toISOString();
      gpsEl.textContent = 'GPS  WN ' + wn + ' · TOW ' + (fine ? groupTow(tow) : groupTow(Math.floor(tow)).slice(0, -3)) + ' s';
      utcEl.textContent = 'UTC  ' + iso.slice(0, 10) + ' ' + iso.slice(11, fine ? 22 : 19) + '  (GPS − ' + LEAP + ' s)';
      if (!clockPlaced) { clockPlaced = true; placeClockDot(); }
    }

    // Four Corners 上空的多系统可见卫星数（统计模型，非实时星历）：
    // GPS / GLONASS / Galileo / BeiDou 各自的可见数随时间缓慢起伏；同一时刻所有访客看到的数字相同
    function skyStats(now) {
      var m = now / 60000;
      function c(base, amp, per, ph) { return base + amp * Math.sin(2 * Math.PI * m / per + ph); }
      var view = c(10.5, 1.6, 47, .3) + c(7, 1.1, 61, 1.7) + c(9, 1.5, 53, 2.9) + c(10.5, 1.8, 71, 4.1);
      var used = c(8, 1.4, 43, 1.1) + c(5.5, 1, 57, 2.2) + c(7, 1.3, 49, .4) + c(8, 1.6, 67, 3.3);
      view = Math.round(view); used = Math.min(Math.round(used), view - 4);
      return { view: view, used: used };
    }

    /* ---- 悬停：在卫星下方多显示一行（星座 · PRN · 轨道 · 仰角） ---- */
    var hover = null;
    function azimuth(p) {
      // 以落点为中心、画面上方为北的示意方位角
      var a = Math.atan2(p.x - geo.L.x, -(p.y - geo.L.y)) * 180 / Math.PI;
      return Math.round((a + 360) % 360);
    }
    sec.addEventListener('mousemove', function (e) {
      if (!geo || geo.mob || !arcs) { hover = null; return; }
      var r = sec.getBoundingClientRect(), mxp = e.clientX - r.left, myp = e.clientY - r.top, best = null, bd = 18 * 18;
      sats.forEach(function (s) {
        if (!s.p || s.f < .3) return;
        var d = (s.p.x - mxp) * (s.p.x - mxp) + (s.p.y - myp) * (s.p.y - myp);
        if (d < bd) { bd = d; best = s; }
      });
      hover = best;
    });
    sec.addEventListener('mouseleave', function () { hover = null; });

    function frame(t) {
      if (!running) return;
      var dt = Math.min(64, t - (lt || t)); lt = t;
      draw(t, dt);
      requestAnimationFrame(frame);
    }
    function start() { if (running || reduce) return; running = true; lt = 0; requestAnimationFrame(frame); }
    function stop() { running = false; }

    build();
    window.addEventListener('resize', function () { clockPlaced = false; build(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { clockPlaced = false; });
    setInterval(function () { clockPlaced = false; }, 2000); // 时间文字宽度可能随字体加载变化，定期重新测量
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', build);
    if (img && !imageReady()) img.addEventListener('load', build, { once: true });
    KMX.onVisible(sec, function (v) { v ? start() : stop(); });
    if (!window.IntersectionObserver) start();
    tick(!reduce);
    if (reduce) setInterval(function () { tick(false); }, 1000);
  }

  function boot() { document.querySelectorAll('.kmx-signal').forEach(initSignal); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // 主题编辑器里重新渲染 section 时重新初始化
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('.kmx-signal'); if (s) initSignal(s); });
})();
